/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UpgradeIneligibilityReason = {
    IncompleteInfo: 'INCOMPLETE_INFO',
    PendingVerification: 'PENDING_VERIFICATION'
} as const;
export type UpgradeIneligibilityReason = typeof UpgradeIneligibilityReason[keyof typeof UpgradeIneligibilityReason];


export function instanceOfUpgradeIneligibilityReason(value: any): boolean {
    for (const key in UpgradeIneligibilityReason) {
        if (Object.prototype.hasOwnProperty.call(UpgradeIneligibilityReason, key)) {
            // @ts-ignore
            if (UpgradeIneligibilityReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UpgradeIneligibilityReasonFromJSON(json: any): UpgradeIneligibilityReason {
    return UpgradeIneligibilityReasonFromJSONTyped(json, false);
}

export function UpgradeIneligibilityReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeIneligibilityReason {
    return json as UpgradeIneligibilityReason;
}

export function UpgradeIneligibilityReasonToJSON(value?: UpgradeIneligibilityReason | null): any {
    return value as any;
}

